import React from "react"


class PlanSuscription extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            section_status : "hide"
            }
    }

    render() {
        return (
           <section>
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Account</h1>
                        <h2>Plan / Suscription</h2>
                        <div className="description">
                            <p>El primer paso es que nos cuentes que variables deseas medir en tu sistema, ayudanos a capturar los sub catalogos para el Magnum Leap. </p>
                        </div>
                    </div>
                    <div className="col-md-3 px-2">     
                        
                    </div>
                </div>
                <div className="suscription"> 
                    <div className="box regular col-md-12">
                        <h3>SUSCRIPCIÓN</h3>
                        <div className="scrollable">
                                <div className="blue-border-box">
                                    <div className="icon"> 
                                        <span className="i-revenue"></span>
                                    </div>
                                    <div className="description"> 
                                        <h5>Módulo contratado: </h5>
                                        <h4>Revenue Intelligence</h4>
                                        <p>Renovación el día 9 de cada mes <br />
                                            1 Suscripción <br />
                                            $550 USD por mes <br />
                                            4 Usuarios incluidos</p>
                                    </div>

                                    <button>VER DETALLES</button>
                                </div>
                                <div className="blue-border-box">
                                    <div className="icon"> 
                                        <span className="i-finance"> </span>
                                    </div>
                                    <div className="description"> 
                                        <h5>Módulo contratado: </h5>
                                        <h4>Finanzas</h4>
                                        <p>Renovación el día 9 de cada mes <br />
                                            1 Suscripción <br />
                                            $550 USD por mes <br />
                                            4 Usuarios incluidos</p>
                                    </div>
                                    <button>VER DETALLES</button>
                                </div>
                                <div className="blue-border-box">
                                    <div className="icon">
                                        <span className="i-ab"></span>
                                    </div>
                                    <div className="description"> 
                                        <h5>Módulo contratado: </h5>
                                        <h4>A&B</h4>
                                        <p>Renovación el día 9 de cada mes <br />
                                            1 Suscripción <br />
                                            $550 USD por mes <br />
                                            4 Usuarios incluidos</p>
                                    </div>
                                    <button>VER DETALLES</button>
                                </div>
                                
                        </div>
                    </div>
                </div>
                <div className="divisor"></div>   

                
            </section>
        )
    }

}

export default PlanSuscription


// WEBPACK FOOTER //
// ./src/Setup/modules/account/views/PlanSuscription.js